module.exports = __webpack_public_path__ + "img/BIOPORT_PLUG.d1c4ec27.svg";